import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

//Occasionally our azure translation service messes up. This is to catch it gracefully.
//It can also occur when we try and translate a non-supported language.

const TranslateAllIssueDialog: React.FunctionComponent<ITranslateAllIssueDialogProps> = props => {
  return (
    <Dialog id="all-translate-missing-language-dialog" open={props.show} onClose={props.onClose} classes={{ container: "my-profile-confirmation-dialog", paper: "my-profile-confirmation-dialog-paper" }}>
      <DialogTitle>Some Languages Couldn't Be Translated</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ color: 'black' }}>
            We translated {props.returnedTranslations} out of {props.totalLanguages} languages.
            Some translations ran into issues and couldn't be loaded.
            Please try translating all languages again, or translate them individually.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button id="all-translate-missing-language-ok-btn" variant="text" color="primary" onClick={props.onClose}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}

interface ITranslateAllIssueDialogProps {
  show: boolean;
  onClose: () => void;
  returnedTranslations: number;
  totalLanguages: number;
}

export default TranslateAllIssueDialog;